import React from 'react';

function Button(props) {
  const {
    buttonHandler, name, className, isDisabled, startIcon, endIcon, title, ...otherProps
  } = props;

  return (
    <button
      type="button"
      className={className || ''}
      disabled={isDisabled}
      onClick={buttonHandler}
      aria-label={name}
      data-testid={name}
      title={title || name}
      {...otherProps}
    >
      {startIcon}
      {name}
      {endIcon}
    </button>
  );
}

export default Button;
